'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Defines a site wide content it takes several properties in order to support header, sub-header and footer.
 *
 * @extends {React.Compponent}
 * @property {Boolean} withHeader Allows space to render a header.
 * @property {Boolean} withSubhead Allows space to render a sub-header.
 * @property {Boolean} withFooter Allows space to render a footer.
 */
class SiteContent extends React.Component {
  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const classes = classNames(
      'SiteContent',
      {'SiteContent--withHeader': this.props.withHeader},
      {'SiteContent--withHeaderAndSubhead': this.props.withHeader && this.props.withSubhead},
      {'SiteContent--withFooter': this.props.withFooter}
    );

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
}

SiteContent.defaultProps = {
  withHeader: false,
  withSubhead: false,
  withFooter: false
};

export default SiteContent;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteContent.jsx